var site = site || {};
var Model = Model || {};
Model.Doors = Model.Doors || {};

(function($) {
  /**
    * Controls panel class handling all functionality for the in-store locator controls bar.
    * On initialization, the class handles the panel rendering, selectors and bind events.
    * You can pass an optional container class or use the default container when initializing.
    * The bindEvents method listens in on not only events triggered within the class, but also ones from other panels.
    * For example, when 'inStoreLocator:launched' is triggered, the init method is called.
  */
  site.controls = function(args) {
    var _args = args || {};
    this.$container = _args.container || '.js-store-check-controls';
    this.$containerOverlay = _args.containerOverlay || '.js-store-check-controls-overlay';
    this.$template = _args.template || 'product_store_check/controls';
    this.$templateInline = _args.templateInline || 'product_store_check/controls_inline';
    this.$templateStores = _args.templateStores || 'product_store_check/controls_stores';
    this.$templateStoresOverlay = _args.templateStoresOverlay || 'product_store_check/controls_stores_overlay';
    this.$templateEdit = _args.templateEdit || 'product_store_check/controls_edit';

    this.dom = {};
    this.activeClass = 'active';
    this.errorDataKey = 'data-error-key';
    this.activeSku = null;
    this.country = null;
    this.countryData = null;
    this.doorData = null;
    this.zipCode = null;
    this.userZipCode = null;
    this.regionId = null;
    this.distanceVal = null;
    this.eventNameSpace = 'controls:';
    this.isMobile = false;
    this.isLoaded = false;
    this.useOverlay = false;
    this.isOverlayOpen = false;
    this.disable_api = false;

    this.bindEvents();
  };

  /**
    * Method to get all DOM selectors when class is initialized.
    * All selectors should be placed here to keep everything located in one spot.
  */
  site.controls.prototype.getNodes = function() {
    this.dom.$container = this.isMobile ? $(this.$containerOverlay) : $(this.$container);
    this.dom.$overlayContainer = $('.js-instore-container');
    this.dom.$controlsContainer = $('.js-controls-container');
    this.dom.$openControlsBtn = $('.js-open-controls');
    this.dom.$openStoreList = $('.js-open-store-list');
    this.dom.$findBtn = $('.js-find-store', this.dom.$container);
    this.dom.$currentLocBtn = $('.js-current-loc', this.dom.$container);
    this.dom.$zipInput = $('.js-zip-input');
    this.dom.$zipInputOverlay = $('.js-zip-input-overlay');
    this.dom.$zipContainer = $('.js-controls-zip', this.dom.$container);
    this.dom.$distanceSelect = $('.js-distance-select', this.dom.$container);
    this.dom.$distanceDefaultInput = $('.js-location-default-distance');
    this.dom.$regionIdsInput = $('.js-region-ids');
    this.dom.$storeTypeInput = $('.js-store-types');
    this.dom.$unitOfMeasurement = $('.js-unit-of-measurement');
    this.dom.$storeTypeClassification = $('.js-store-types-classification');
    this.dom.$inputSelects = $('.js-input-select', this.dom.$container);
    this.dom.$errorNodes = $('.js-controls-error');
    this.dom.$errorOverlayNodes = $('.js-controls-error', this.$containerOverlay);
    this.dom.$errorContainer = $('.js-error-container');
    this.dom.$errorOverlayContainer = $('.js-error-container', this.$containerOverlay);
    this.dom.$closeLink = $('.js-controls-close');
    this.dom.$closeLinkOverlay = $('.js-controls-overlay-close', this.dom.$container);
    this.dom.$editLink = $('.js-controls-edit', this.dom.$container);
    this.dom.$changeLocLink = $('.js-location-change');
    this.dom.$changeLocLinkOverlay = $('.js-location-change-overlay');
    //this.dom.$ShowZipcodelink = $('.js-check-other__availability');
    //this.dom.$Zipcodesection = $('.js-location-controls__zip');
    this.dom.$mobileOverlay = $('.js-store-check-overlay');
    this.dom.$ContainerAvailableDoors = $('.js-inline-container__available--doors');
    this.dom.$ContainerAvailableDoorsOverlay = $('.js-inline-container__available--doors-overlay');
    this.dom.$countryNameInput = $('.js-country-name');
    this.dom.$loadingIcon = $('.js-loading,.js-overlay-loading');
  };

  /**
    * Method to set all bind events when class is initialized.
    * All bind events, including events from other panels, should be placed here.
  */
  site.controls.prototype.bindEvents = function() {
    $(document).on(this.eventNameSpace + 'init', $.proxy(this.init, this));
    $(document).on(this.eventNameSpace + 'init:stores', $.proxy(this.initStores, this));
    $(document).on(this.eventNameSpace + 'init:stores:overlay', $.proxy(this.initStoresOverlay, this));
    $(document).on(this.eventNameSpace + 'init:edit', $.proxy(this.initEdit, this));
    $(document).on(this.eventNameSpace + 'update', $.proxy(this.update, this));
    $(document).on(this.eventNameSpace + 'distance:set', $.proxy(this.setDistance, this));
    $(document).on(this.eventNameSpace + 'zip:change', $.proxy(this.setZipDisplay, this));
    $(document).on(this.eventNameSpace + 'zip:set:loc', $.proxy(this.setCurrentLocationZip, this));
    $(document).on(this.eventNameSpace + 'reset', $.proxy(this.reset, this));
    $(document).on(this.eventNameSpace + 'refreshSelects', $.proxy(this.refreshSelects, this));
    $(document).on(this.eventNameSpace + 'data:loaded', $.proxy(this.setCountryData, this));
    $(document).on(this.eventNameSpace + 'errors:load', $.proxy(this.loadErrors, this));
    $(document).on(this.eventNameSpace + 'hideErrors', $.proxy(this.hideErrors, this));
    $(document).on(this.eventNameSpace + 'hideOverlayErrors', $.proxy(this.hideOverlayErrors, this));
    $(document).on(this.eventNameSpace + 'displayErrors', $.proxy(this.displayErrors, this));
    $(document).on(this.eventNameSpace + 'showLoadingIcon', $.proxy(this.showLoadingIcon, this));
    $(document).on(this.eventNameSpace + 'hideLoadingIcon', $.proxy(this.hideLoadingIcon, this));
    $(document).on(this.eventNameSpace + 'close:show', $.proxy(this.showCloseBtn, this));
    $(document).on(this.eventNameSpace + 'close:hide', $.proxy(this.hideCloseBtn, this));
    $(document).on(this.eventNameSpace + 'closeControls', $.proxy(this.resetDisplay, this));
    $(document).on('display:overlay:use', $.proxy(this.setOverlayFlag, this));
    $(document).on('display:overlay:opened', $.proxy(this.onOverlayOpen, this));
    $(document).on('display:overlay:closed', $.proxy(this.onOverlayClose, this));
    $(document).on('inStoreLocator:reset', $.proxy(this.removeEvents, this));
    $(document).on('inStoreLocator:device:set', $.proxy(this.setMobileFlag, this));
    $(document).on('MPP:quickshopsDestroyed', $.proxy(this.removeEvents, this));
    $(document).on('display:sku:set', $.proxy(this.onSkuChange, this));
    $(document).on('display:loaded:set', $.proxy(this.setLoaded, this));
    $(document).on('display:loaded:unset', $.proxy(this.unsetLoaded, this));
    $(document).on('DoorsInventory:query:success', $.proxy(this.querySuccess, this));
    $(document).on('DoorsInventory:query:failure', $.proxy(this.queryFailure, this));
  };

  /**
    * Initialization method called when the locator overlay is displayed through the event 'inStoreLocator:launched'.
    * Handles rendering of the controls panel along with adding additional functionality.
  */
  site.controls.prototype.init = function(e, args) {
    this.render({
      template: this.$template
    });
    this.setInlineControls();
    this.loadErrors();
  };

  /**
    * Initialization method called when the locator overlay is displayed through the event 'inStoreLocator:launched'.
    * Handles rendering of the controls panel along with adding additional functionality.
  */
  site.controls.prototype.initStores = function(e) {
    this.render({
      template: this.$templateStores,
      container: this.$container
    });
    this.setInlineControls();
    this.setZipDisplay();
    this.setDefaultDistance();
    this.setRegion();
    this.setCountry();
    this.refreshSelects();
    this.loadErrors();
  };

  /**
    * Initialization method called when the locator overlay is displayed through the event 'inStoreLocator:launched'.
    * Handles rendering of the controls panel along with adding additional functionality.
  */
  site.controls.prototype.initStoresOverlay = function(e) {
    this.render({
      template: this.$templateStoresOverlay,
      container: this.$containerOverlay
    });
    this.getNodes();
    this.setOverlayControls();
    this.setZipDisplay();
    this.setDefaultDistance();
    this.setRegion();
    this.setCountry();
    this.refreshSelects();
    this.loadOverlayErrors();
  };

  /**
    * Initialization method called when the locator overlay is displayed through the event 'inStoreLocator:launched'.
    * Handles rendering of the controls panel along with adding additional functionality.
  */
  site.controls.prototype.initEdit = function(e, args) {
    var _args = args || {};

    this.render({
      template: this.$templateEdit
    });
    this.setInlineControls();
    this.setDefaultDistance();
    this.loadErrors();
    this.setCloseBtn();
    //this.setToggleControls();
  };

  /**
    * Method to render and insert the controls panel to the in-store locator.
    * Uses the template argument passed and if it isn't available, it will use the default.
    * Once the inline template is found, it is placed in a local dom var, for future reference, and then inserted.
  */
  site.controls.prototype.render = function(args) {
    var _args = args || {};
    var template = _args.template || 'product_store_check/controls';
    var _inlineTemplate = $("script.inline-template[path='" + template + "']").html();

    this.dom.$container = _args.container ? $(_args.container) : $(this.$container);
    this.dom.$container.html(_inlineTemplate);
  };

  /**
    * Method used to make sure the selectBoxes in the controls panel are initialized.
  */
  site.controls.prototype.renderSelects = function() {
    if (!this.dom.$inputSelects || !this.dom.$inputSelects.selectBox) {
      return null;
    }

    this.dom.$inputSelects.selectBox();
  };

  /**
    * Method to set the click event on this.dom.$openControlsBtn for inline display.
    * Fires the event 'controls:toggleControlsContainer' to hide or show the controls.
  */
  site.controls.prototype.setInlineControls = function() {
    var that = this;

    that.getNodes();
    that.dom.$openStoreList.bind('click', function(e) {
      e.preventDefault();
      if (that.isMobile) {
        $(document).trigger('display:overlay:init', {enableOverlay: true});
      } else {
        $(document).trigger('display:inline:stores', {reload: true});
      }
    });

    that.dom.$editLink.bind('click', function(e) {
      e.preventDefault();
      $(document).trigger(that.eventNameSpace + 'hideErrors');
      $(document).trigger('display:inline:edit');
    });
    that.dom.$closeLink.bind('click', function(e) {
      e.preventDefault();
      $(document).trigger(that.eventNameSpace + 'hideErrors');
      $(document).trigger('display:reset');
    });
    that.dom.$changeLocLink.bind('click', function(e) {
      e.preventDefault();
      that.disable_api = true;
      var zip = that.dom.$zipInput.val();
      $(document).trigger(that.eventNameSpace + 'hideErrors');
      $(document).trigger(that.eventNameSpace + 'update', {zipCode: zip, disable_api: that.disable_api});
      generic.focusErrors($('.js-error-messages'), $('.js-instore-container'));
    });

    that.dom.$zipInput.bind('keyup', function(e) {
      that.disable_api = true;
      var zip = that.dom.$zipInput.val();
      if (e.keyCode == '13') {
        $(document).trigger(that.eventNameSpace + 'hideErrors');
        $(document).trigger(that.eventNameSpace + 'update', {zipCode: zip, disable_api: that.disable_api});
      }
    });
    that.dom.$distanceSelect.bind('change', function(e) {
      e.preventDefault();
      that.disable_api = true;
      $(document).trigger(that.eventNameSpace + 'hideErrors');
      $(document).trigger(that.eventNameSpace + 'distance:set');
      $(document).trigger(that.eventNameSpace + 'update', {zipCode: that.zipCode, disable_api: that.disable_api});
    });
  };

  /**
    * Method to set the click event on this.dom.$openControlsBtn for inline display.
    * Fires the event 'controls:toggleControlsContainer' to hide or show the controls.
  */
  site.controls.prototype.setOverlayControls = function() {
    var that = this;

    that.getNodes();
    that.dom.$closeLinkOverlay.bind('click', function(e) {
      e.preventDefault();
      $(document).trigger(that.eventNameSpace + 'hideOverlayErrors');
      $(document).trigger(that.eventNameSpace + 'reset');
      $(document).trigger('display:overlay:close');
    });
    that.dom.$changeLocLinkOverlay.bind('click', function(e) {
      e.preventDefault();
      that.disable_api = true;
      var zip = that.dom.$zipInputOverlay.val();
      $(document).trigger(that.eventNameSpace + 'hideOverlayErrors');
      $(document).trigger(that.eventNameSpace + 'update', {zipCode: zip, disable_api: that.disable_api});
      if (that.dom.$mobileOverlay.hasClass('psc-state-error')) {
        that.dom.$ContainerAvailableDoorsOverlay.addClass('hidden');
      }
    });
    that.dom.$zipInputOverlay.bind('keyup', function(e) {
      that.disable_api = true;
      var zip = that.dom.$zipInputOverlay.val();
      if (e.keyCode == '13') {
        $(document).trigger(that.eventNameSpace + 'hideOverlayErrors');
        $(document).trigger(that.eventNameSpace + 'update', {zipCode: zip, disable_api: that.disable_api});
        if (that.dom.$mobileOverlay.hasClass('psc-state-error')) {
          that.dom.$ContainerAvailableDoorsOverlay.addClass('hidden');
        }
      }
    });
    that.dom.$distanceSelect.bind('change', function(e) {
      e.preventDefault();
      that.disable_api = true;
      $(document).trigger(that.eventNameSpace + 'hideOverlayErrors');
      $(document).trigger(that.eventNameSpace + 'distance:set');
      $(document).trigger(that.eventNameSpace + 'update', {zipCode: that.zipCode, disable_api: that.disable_api});
    });
  };

  /**
    * Method used to reset the control fields for the panel.
    * Can be triggered by using the event 'controls:reset'.
  */
  site.controls.prototype.reset = function() {
    this.dom.$zipInput.val('');
    this.dom.$zipInput.focus();
    $(document).trigger(this.eventNameSpace + 'hideErrors');
  };

  /**
    * Method to bind the click event on the find button in the controls panel.
    * Uses the Model DoorsInventory to trigger the inventory door query.
    * Also triggers the event 'controls:currentZipCode'
    * to let other panels know about the current zipcode.
  */
  site.controls.prototype.update = function(e, args) {
    var that = this;
    var _args = args || {};

    that.regionId = that.dom.$regionIdsInput.val() || that.regionId;
    that.storeTypes = that.dom.$storeTypeInput.val();
    that.uom = that.dom.$unitOfMeasurement.val();
    that.storeTypesClassification = that.dom.$storeTypeClassification.val();
    if (Drupal.settings.common && Drupal.settings.common.enable_store_order) {
      that.storeTypesClassification = that.storeTypesClassification.replace(/&/g, ',');
    }
    if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing) {
      var $selectedSku = $('.js-sku-price');
      if ($selectedSku.length) {
        _args.activeSku = $selectedSku.attr('data-sku-id').slice(3);
      }
      _args.enable_zip = true;
    }
    var args = {
      zip: _args.zipCode,
      skus: _args.activeSku || that.activeSku,
      radius: that.distanceVal,
      region_id: that.regionId,
      uom: that.uom,
      disable_api: Drupal.settings.common.disable_auto_spoofing ? _args.disable_api : '',
      //inv_store_types : that.storeTypes,
      inv_store_classification: that.storeTypesClassification // Aveda uses CLASSIFICATION for filter instead of STORE_TYPE
    };
    if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing) {
      args.callback = function() {
        $(document).trigger('inStoreLocator:layout:init', _args);
      };
    }
    Model.DoorsInventory.load(args);
  };

  /**
    * Method responsible for setting the default option of the distance drop down.
    * It looks for the default value in a hidden input in the dom.
    * Then it sets the distance drop down to that option if available.
  */
  site.controls.prototype.setDefaultDistance = function() {
    if (!this.dom.$distanceDefaultInput[0] && !this.dom.$distanceSelect[0]) {
      return null;
    }

    this.distanceVal = this.distanceVal || this.dom.$distanceDefaultInput.val();
    if (this.distanceVal) {
      this.dom.$distanceSelect.val(this.distanceVal);
    }
    $(document).trigger(this.eventNameSpace + 'distance:change', this.distanceVal);
  };

  /**
    * Method responsible for setting the distance drop down.
  */
  site.controls.prototype.setDistance = function() {
    this.distanceVal = this.dom.$distanceSelect.val();
    $(document).trigger(this.eventNameSpace + 'distance:change', this.distanceVal);
  };

  /**
    * Method responsible for setting the region for the locator.
    * It looks for the region value set in a hidden input set by the CMS.
    * Then it sets the controls var regionId to be used when needed.
  */
  site.controls.prototype.setRegion = function() {
    this.regionId = this.regionId || this.dom.$regionIdsInput.val();
  };

  /**
    * Method responsible for setting the country for the locator.
    * It looks for the country value set in a hidden input set by the CMS.
    * Then it sets the controls var country to be used when needed.
    * @returns {void}
  */
  site.controls.prototype.setCountry = function() {
    this.country = this.country || this.dom.$countryNameInput.val();
  };

  /**
    * Helper method used to trigger the find button.
    * Used for the inline display to get the door data immediiately when locator is displayed.
    * Could you be used similar scenarios where you want to display the door info without waiting for user input.
  */
  site.controls.prototype.setCurrentLocBtn = function() {
    var that = this;
    that.dom.$currentLocBtn.bind('click', function(e) {
      e.preventDefault();
      var args = {
        useHeader: true,
        skus: that.activeSku,
        region_id: that.dom.$regionIdsInput.val(),
        radius: that.dom.$distanceSelect.val()
      };
      Model.DoorsInventory.load(args);
    });
  };

  /**
    * Method that handles changes when the product sku select is changed in another panel class.
    * When the sku is changed, it sets the internal variable this.activeSku with the skuId.
  */
  site.controls.prototype.onSkuChange = function(e, sku) {
    this.activeSku = (typeof sku === 'object' && sku.SKU_BASE_ID) ? sku.SKU_BASE_ID : sku;
    if (this.isLoaded) {
      $(document).trigger(this.eventNameSpace + 'update', {zipCode: this.userZipCode});
      $(document).trigger('display:loaded:unset');
    }
  };

  /**
    * Method that handles what happens when the inventory locator query fails.
  */
  site.controls.prototype.queryFailure = function(e, results) {
    $(document).trigger('inStoreLocator:state:set', {state: 'error', setOverlay: this.isOverlayOpen});
    $(document).trigger(this.eventNameSpace + 'displayErrors', results);
    $(document).trigger(this.eventNameSpace + 'hideLoadingIcon');
  };

  /**
    * Method that handles what happens when the inventory locator query fails.
  */
  site.controls.prototype.querySuccess = function(e, results) {
    $(document).trigger(this.eventNameSpace + 'hideLoadingIcon');
    this.doorData = (results && results.sorted) ? results.sorted : null;
  };

  /**
    * Method to display errors within the control panel.
    * Iterates through the error nodes hidden in the controls panel mustache template.
    * When an error key is passed, it will display the error node.
    * The method expects results to be a data object with the param error, that is an array of objects.
  */
  site.controls.prototype.displayErrors = function(e, results) {
    var container = (this.useOverlay && this.isOverlayOpen) ? this.$containerOverlay : this.$container;
    if (results && $.isArray(results.errors)) {
      for (var x = 0; x < results.errors.length; x++) {
        $('[' + this.errorDataKey + '="' + results.errors[x].key + '"]', container).addClass(this.activeClass);
      }
    }
  };

  /* Method used to show the loading icon in the DOM.*/
  site.controls.prototype.showLoadingIcon = function() {
    this.getNodes();
    this.dom.$loadingIcon.removeClass('hidden');
    $('body').addClass('ajax-wait-inventory');
  };

  /* Method used to show the loading icon in the DOM.*/
  site.controls.prototype.hideLoadingIcon = function() {
    this.getNodes();
    this.dom.$loadingIcon.addClass('hidden');
    $('body').removeClass('ajax-wait-inventory');
  };

  /**
    * Method to hide all error nodes when called.
    * Can be called directly within the controls panel or by using the event 'controls:hideErrors'.
  */
  site.controls.prototype.hideErrors = function() {
    this.getNodes();
    this.dom.$errorNodes.removeClass(this.activeClass);
  };

  /**
    * Method used to hide overlay errors display.
  */
  site.controls.prototype.hideOverlayErrors = function() {
    this.getNodes();
    this.dom.$errorOverlayNodes.removeClass(this.activeClass);
  };

  /**
    * Method used to set the global useOverlay flag to true.
  */
  site.controls.prototype.setOverlayFlag = function(e, args) {
    this.useOverlay = true;
  };

  /**
    * Method used to handle control events when the overlay is opened.
  */
  site.controls.prototype.onOverlayOpen = function(e, args) {
    this.isOverlayOpen = true;
  };

  /**
    * Method used to handle control events when the overlay is closed.
  */
  site.controls.prototype.onOverlayClose = function(e, args) {
    this.isOverlayOpen = false;
    this.dom.$zipInput.val('');
    this.dom.$zipInputOverlay.val('');
  };

  /**
    * Method used to set the global isMobile flag.
  */
  site.controls.prototype.setMobileFlag = function(e, isMobile) {
    this.isMobile = isMobile;
  };

  /**
    * Method used to insert the current zip code into the DOM.
  */
  site.controls.prototype.setZipDisplay = function(e, args) {
    var _args = args || {};
    this.zipCode = _args.zip || this.zipCode;
    if (site.templates && site.templates['product_store_check_layout']) {
      var postCode = site.templates['product_store_check_layout'].data.placeholder_zipcode;
      if (this.zipCode && this.zipCode.indexOf(postCode) > -1) {
        postCode = postCode + ' ';
        this.zipCode = this.zipCode.replace(postCode, '');
      }
    }
    this.dom.$zipContainer.html(this.zipCode);
  };

  site.controls.prototype.setCurrentLocationZip = function(e, args) {
    var _args = args || {};
    this.userZipCode = _args.zip;
  };

  /**
    * Method used to refresh the select library used for the brand.
    * NOTE: This will probably be different for each brand implementation.
  */
  site.controls.prototype.refreshSelects = function(e) {
    $(document).trigger('selectBox.reInit');
  };

  /**
    * Method used to render the errors template into the DOM.
  */
  site.controls.prototype.loadErrors = function(e) {
    var _inlineTemplate = $("script.inline-template[path='product_store_check/errors']").html();
    this.dom.$errorContainer.html(_inlineTemplate);
  };

  /**
    * Method used to render the errors template into the DOM, but for the overlay.
  */
  site.controls.prototype.loadOverlayErrors = function(e) {
    var _inlineTemplate = $("script.inline-template[path='product_store_check/errors']").html();
    this.dom.$errorOverlayContainer.html(_inlineTemplate);
  };

  /**
    * Method used to handle the logic for the close button display.
  */
  site.controls.prototype.setCloseBtn = function() {
    if (this.isLoaded) {
      $(document).trigger(this.eventNameSpace + 'close:show');
    } else {
      $(document).trigger(this.eventNameSpace + 'close:hide');
    }
  };

  /**
    * Method used to hide the close button node in the DOM.
  */
  site.controls.prototype.hideCloseBtn = function() {
    this.dom.$closeLink.addClass('hidden');
  };

  /**
    * Method used to show the close button node in the DOM.
  */
  site.controls.prototype.showCloseBtn = function() {
    this.dom.$closeLink.removeClass('hidden');
  };

  /**
    * Method used to set the global isLoaded flag.
    * isLoaded is used to determine if the user has loaded the app.
    * In certain scenarios, the initial load needs to be handle differently then subsequent actions.
  */
  site.controls.prototype.setLoaded = function() {
    this.isLoaded = true;
  };

  /**
    * Method used to unset the global isLoaded flag.
  */
  site.controls.prototype.unsetLoaded = function() {
    this.isLoaded = false;
  };

  /**
    * Method to unbind all events associated to document.
    * Calls the inStoreLocator event removeEvents passing the current namespace.
  */
  site.controls.prototype.removeEvents = function(e) {
    var that = this;
    $(document).trigger('inStoreLocator:removeEvents', {
      nameSpace: that.eventNameSpace
    });
  };

})(jQuery);
